// extracted by mini-css-extract-plugin
export default {"container":"EditProjectPage_container__Xw3iU","content":"EditProjectPage_content__j+jsH","column":"EditProjectPage_column__3juzS","row":"EditProjectPage_row__eUAe9"};